import * as constants from '../appConstants';
import { signHeaders, getQueryString } from './signatureHelper';
import { cloneDeep } from 'lodash';

export function buildRequest(host: string, formData: any, authValues: any, apiRequest: string) {

    const pathParam = formData.formData.pathParam;

    // the Object returned by react-jsonschema-form will contain many empty objects
    // these need to be cleared out, otherwise Proxima returns an error 500
    const payload = cloneDeep(formData.formData.payload);
    clearEmpties(payload);

    const queryParams = cloneDeep(formData.formData.queryParams);
    clearEmpties(queryParams);

    const queryParameters = queryParams;

    // schema UI doesn't produce the exact JSON format we need for addressRestrictions,
    // so we need to manipulate the structure of the underlying object a bit
    if ((payload)
            && (payload.deliverySpecifications)
            && (payload.deliverySpecifications.addressRestrictions)
            && (payload.deliverySpecifications.addressRestrictions.restrictions)) {
        const dsar = payload.deliverySpecifications.addressRestrictions;
        dsar.restrictionsX = {};

        for (const restriction of dsar.restrictions) {
            const countryCode = restriction.countryCode;
            delete restriction.countryCode;
            dsar.restrictionsX[countryCode] = {};
            if (restriction.dependencies) {
                dsar.restrictionsX[countryCode].statesOrRegions = restriction.dependencies.statesOrRegions;
                dsar.restrictionsX[countryCode].zipCodes = restriction.dependencies.zipCodes;
            }
        }
        dsar.restrictions = dsar.restrictionsX;
        delete dsar.restrictionsX;
    }

    // similar issue with JSON structure for Delivery Trackers API
    // API expects the deliveryDetails object to be passed in as an array
    if ((payload) && (payload.deliveryDetails)) {
        payload.deliveryDetails = [payload.deliveryDetails];
    }

    let options = {
            // inputs
        host : '',
        payload: JSON.stringify(payload, null, 4),
        headers: formData.formData.header,
        method: '',
        urlFragment: '',
        queryParams: queryParameters,
            // intermediate outputs
        signedHeaders: {},
        canonicalRequest: '',
        stringToSign: '',
        outputHeaders: '',
            // api outputs
        status: '',
        requestId: '',
        responseBody: '',
        formData: ''
   };

    switch (apiRequest) {
        case constants.ApiType.CREATE_CHECKOUT_SESSION:
            options.method = 'POST';
            options.urlFragment = constants.ApiPath.CHECKOUT_SESSIONS;
            break;
        case constants.ApiType.GET_CHECKOUT_SESSION:
            options.method = 'GET';
            options.urlFragment = constants.ApiPath.CHECKOUT_SESSIONS + '/' + pathParam;
            break;
        case constants.ApiType.UPDATE_CHECKOUT_SESSION:
            options.method = 'PATCH';
            options.urlFragment = constants.ApiPath.CHECKOUT_SESSIONS + '/' + pathParam;
            break;
        case constants.ApiType.COMPLETE_CHECKOUT_SESSION:
            options.method = 'POST';
            options.urlFragment = constants.ApiPath.CHECKOUT_SESSIONS + '/' + pathParam + '/complete';
            break;
        case constants.ApiType.FINALIZE_CHECKOUT_SESSION:
            options.method = 'POST';
            options.urlFragment = constants.ApiPath.CHECKOUT_SESSIONS + '/' + pathParam + '/finalize';
            break;
        case constants.ApiType.GET_CHARGE_PERMISSION:
            options.method = 'GET';
            options.urlFragment = constants.ApiPath.CHARGE_PERMISSIONS + '/' + pathParam;
            break;
        case constants.ApiType.UPDATE_CHARGE_PERMISSION:
            options.method = 'PATCH';
            options.urlFragment = constants.ApiPath.CHARGE_PERMISSIONS + '/' + pathParam;;
            break;
        case constants.ApiType.CLOSE_CHARGE_PERMISSION:
            options.method = 'DELETE';
            options.urlFragment = constants.ApiPath.CHARGE_PERMISSIONS + '/' + pathParam + '/close';
            break;
        case constants.ApiType.GET_CHARGE:
            options.method = 'GET';
            options.urlFragment = constants.ApiPath.CHARGES + '/' + pathParam;
            break;
        case constants.ApiType.CREATE_CHARGE:
            options.method = 'POST';
            options.urlFragment = constants.ApiPath.CHARGES;
            break;
        case constants.ApiType.CAPTURE_CHARGE:
            options.method = 'POST';
            options.urlFragment = constants.ApiPath.CHARGES + '/' + pathParam + '/capture';
            break;
        case constants.ApiType.CANCEL_CHARGE:
            options.method = 'DELETE';
            options.urlFragment = constants.ApiPath.CHARGES + '/' + pathParam + '/cancel';
            break;
        case constants.ApiType.CREATE_REFUND:
            options.method = 'POST';
            options.urlFragment = constants.ApiPath.REFUNDS;
            break;
        case constants.ApiType.GET_REFUND:
            options.method = 'GET';
            options.urlFragment = constants.ApiPath.REFUNDS + '/' + pathParam;
            break;
        case constants.ApiType.DELIVERY_TRACKER:
            options.method = 'POST';
            options.urlFragment = constants.ApiPath.DELIVERY_TRACKERS;
            break;
        case constants.ApiType.GET_BUYER:
            options.method = 'GET';
            options.urlFragment = constants.ApiPath.BUYERS + '/' + pathParam;
            break;
        case constants.ApiType.GET_REPORTS:
            options.method = 'GET';
            options.urlFragment = constants.ApiPath.REPORTS + getQueryString(queryParams);
            break;
        case constants.ApiType.GET_REPORT_BY_ID:
            options.method = 'GET';
            options.urlFragment = constants.ApiPath.REPORTS + '/' + pathParam;
            break;
        case constants.ApiType.CREATE_REPORT:
            options.method = 'POST';
            options.urlFragment = constants.ApiPath.REPORTS;
            break;
        case constants.ApiType.GET_REPORT_DOCUMENT:
            options.method = 'GET';
            options.urlFragment = constants.ApiPath.REPORT_DOCUMENTS + '/' + pathParam;
            break;
        default:
    }

    if (host === constants.CLOUD_DEV_DESKTOP || host === constants.LOCALHOST) {
        options.host = "pay-api.amazon.com";
    } else {
        options.host = host;
    }

    const signedComponents = signHeaders(options, authValues);
    options.signedHeaders = signedComponents.headers;
    options.canonicalRequest = signedComponents.canonicalRequest;
    options.stringToSign = signedComponents.stringToSign;

    Object.keys(signedComponents.headers).forEach(item => options.outputHeaders += item + ':' + signedComponents.headers[item] + '\n');

    return options;
}

function clearEmpties(obj) {
    for (var k in obj) {
        if (!obj[k] || typeof obj[k] !== "object") {
            // check if we can delete the empty string
            if (!obj[k] || typeof obj[k] === "string") {
                if (obj[k].length === 0) {
                    delete obj[k];
                }
            }
            continue;
        }

       clearEmpties(obj[k]);
       // check if we can delete object with nothing in it
       if (Object.keys(obj[k]).length === 0) {
           delete obj[k];
        }
    }
}
